import React, { useState } from "react";

// Controlled chip editor backed by the managed cars list.
// Props: { value = [], onChange, cars = [], onCreateCar }
export default function FitmentEditor({ value = [], onChange, cars = [], onCreateCar, id }) {
  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);

  // Find a car in the managed list by case-insensitive exact match.
  const findExisting = (raw) => {
    const lower = (raw || "").trim().toLowerCase();
    return cars.find((c) => c.name.toLowerCase() === lower);
  };

  const add = (raw) => {
    const name = (raw || "").trim();
    if (!name) return;
    if (value.some((v) => v.toLowerCase() === name.toLowerCase())) {
      setText(""); setOpen(false); return;
    }
    onChange([...value, name]);
    setText(""); setOpen(false);
  };

  const removeAt = (i) => onChange(value.filter((_, idx) => idx !== i));

  const doCreate = (raw) => {
    const name = (raw || "").trim();
    if (!name) return;
    if (onCreateCar) onCreateCar(name);
    add(name);
  };

  const commit = (raw) => {
    const name = (raw || "").trim();
    if (!name) return;
    const existing = findExisting(name);
    if (existing) {
      add(existing.name); // use canonical casing
    } else {
      doCreate(name);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit(text);
    }
  };

  // On blur: only commit a known canonical car; discard unknown text (no chip, no create).
  const onBlur = () => {
    const name = text.trim();
    if (name) {
      const existing = findExisting(name);
      if (existing) add(existing.name);
    }
    setText("");
    setOpen(false);
  };

  const trimmed = text.trim();
  const suggestions = trimmed
    ? cars.filter(
        (c) =>
          c.name.toLowerCase().includes(trimmed.toLowerCase()) &&
          !value.some((v) => v.toLowerCase() === c.name.toLowerCase())
      )
    : cars.filter((c) =>
        !value.some((v) => v.toLowerCase() === c.name.toLowerCase())
      );
  const exactMatch = cars.some((c) => c.name.toLowerCase() === trimmed.toLowerCase());
  const showCreate = trimmed !== "" && !exactMatch;
  const dropdownVisible = open && (suggestions.length > 0 || showCreate);

  return (
    <div className="fitment-editor">
      {value.length > 0 && (
        <div className="fitment-chips">
          {value.map((car, i) => (
            <span key={`${car}-${i}`} className="fitment-chip">
              {car}
              <button type="button" className="fitment-chip__x" aria-label={`Hapus ${car}`}
                onClick={() => removeAt(i)}>×</button>
            </span>
          ))}
        </div>
      )}
      <div className="combobox">
        <input
          id={id}
          className="form-input"
          value={text}
          placeholder="Ketik mobil lalu Enter (mis. PS 100)"
          onChange={(e) => { setText(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
        />
        {dropdownVisible && (
          <div className="combobox__menu">
            {suggestions.map((c) => (
              <div key={c.name} className="combobox__option"
                onMouseDown={(e) => { e.preventDefault(); add(c.name); }}>
                <div className="combobox__option-primary">{c.name}</div>
              </div>
            ))}
            {showCreate && (
              <div className="combobox__option combobox__create"
                onMouseDown={(e) => { e.preventDefault(); doCreate(trimmed); }}>
                + Tambah mobil baru: {trimmed}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
